module.exports = __webpack_public_path__ + "img/casebg4.431fbd8a.png";